import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import styled from "styled-components";

const { carbon } = colorsPalettes;

const GridRow = styled.div`
    margin-top: 12px;
`;
const GridItem = styled.div`
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const GridItemRightAlignment = styled.div`
    text-align: right;
`;
const Text = styled.div<{ marginRight?: string }>`
    cursor: default;
    ${setFont({ $size: 14, $color: rgba(colorsPalettes.carbon[500], 1) })}
`;
const Pill = styled.span<{ isBeta?: boolean }>`
    letter-spacing: 0.6px;
    border-radius: 10px;
    font-weight: 500;
    color: ${colorsPalettes.carbon["0"]};
    padding: 4px 5px 3px 5px;
    line-height: 1;
    text-align: left;
    width: auto;
    margin-left: 10px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: none;
    height: 13px;
    ${setFont({ $size: 12 })}
    ${({ isBeta }) =>
        isBeta ? `background-color: ${colorsPalettes.green.s100}` : `background-color: ${colorsPalettes.red.s100}`};
`;
const ChartLabelTooltipContainer = styled.div<{ tooltipWidth?: string }>`
    width: ${({ tooltipWidth }) => tooltipWidth};
    background-color: white;
    padding: 15px;
    border-radius: 6px;
    box-shadow: 0 6px 6px 0 ${colorsPalettes.carbon[200]};
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const Title = styled.span`
    display: block;
    ${setFontVariant("h5", carbon[500])};
`;

const SubTitle = styled.span`
    ${setFontVariant("chip1", carbon[400])}
`;

const flipColor = (positiveAvg, vertical) => {
    if (vertical.id === "BounceRate") {
        return !positiveAvg;
    }
    return positiveAvg;
};

export const ChartLabelTooltip = ({
    chart,
    getAverageForBenchmark,
    xVertical,
    yVertical,
    aboveAvgText = "Above Avg.",
    belowAvgText = "Below Avg.",
    tooltipWidth,
}) => {
    const xAboveAvg = chart.hoverPoint.x > getAverageForBenchmark(xVertical);
    const yAboveAvg = chart.hoverPoint.y > getAverageForBenchmark(yVertical);
    const { hoverSeries = {} } = chart;
    const { userOptions = {} } = hoverSeries;
    const { name, subName } = userOptions;
    return (
        <ChartLabelTooltipContainer tooltipWidth={tooltipWidth}>
            <div>
                <Title>{name}</Title>
                {subName ? <SubTitle>{subName}</SubTitle> : null}
            </div>
            <div>
                <GridRow style={{ display: "flex", alignItems: "center" }}>
                    <GridItem style={{ flex: "0 0 40%", marginRight: 10 }}>
                        <Text>{xVertical.name}</Text>
                    </GridItem>
                    <GridItemRightAlignment style={{ flex: "0 0 25%", flexShrink: 0 }}>
                        <Text>{xVertical.formatter(chart.hoverPoint.x)}</Text>
                    </GridItemRightAlignment>

                    <GridItemRightAlignment style={{ flex: "0 1 35%", flexShrink: 0, overflow: "hidden" }}>
                        {!xVertical.hidePill ? (
                            <Text>
                                <Pill isBeta={flipColor(xAboveAvg, xVertical)}>
                                    {xAboveAvg ? aboveAvgText : belowAvgText}
                                </Pill>
                            </Text>
                        ) : null}
                    </GridItemRightAlignment>
                </GridRow>
                <GridRow style={{ display: "flex", alignItems: "center" }}>
                    <GridItem style={{ flex: "0 0 40%", marginRight: 10 }}>
                        <Text>{yVertical.name}</Text>
                    </GridItem>
                    <GridItemRightAlignment style={{ flex: "0 0 25%", flexShrink: 0 }}>
                        <Text>{yVertical.formatter(chart.hoverPoint.y)}</Text>
                    </GridItemRightAlignment>

                    <GridItemRightAlignment style={{ flex: "0 1 35%", flexShrink: 0, overflow: "hidden" }}>
                        {!yVertical.hidePill ? (
                            <Text>
                                <Pill isBeta={flipColor(yAboveAvg, yVertical)}>
                                    {yAboveAvg ? aboveAvgText : belowAvgText}
                                </Pill>
                            </Text>
                        ) : null}
                    </GridItemRightAlignment>
                </GridRow>
            </div>
        </ChartLabelTooltipContainer>
    );
};
